import { createApp } from 'vue'
import App from './App.vue'
import router from "./router";
import AOS from 'aos'
import 'aos/dist/aos.css'
import i18n from './i18n'
import store from "./state/store";
import VueProgressBar from "@aacassandra/vue3-progressbar";

import BootstrapVue3 from 'bootstrap-vue-3';
import vClickOutside from "click-outside-vue3"
import VueApexCharts from "vue3-apexcharts";
import Maska from 'maska';

import VueFeather from 'vue-feather';
import Particles from "particles.vue3";

import '@/assets/scss/config/default/app.scss';
import '@vueform/slider/themes/default.css';

import "./http/api";
import Price from "@/views/globals/components/Price.vue"
import NumericValue from "@/views/globals/components/NumericValue.vue"
import Jalali from "@/views/globals/components/Jalali.vue"

import Notifications from '@kyvg/vue3-notification'

AOS.init({
    easing: 'ease-out-back',
    duration: 1000
})



const options = {
    color: "#bffaf3",
    failedColor: "#874b4b",
    thickness: "2px",
    transition: {
        speed: "0.2s",
        opacity: "0.6s",
        termination: 300,
    },
    autoRevert: true,
    location: "left",
    inverse: false,
};



import generalMixin from "@/mixins/general-mixin";
const app = createApp(App)
    .use(store)
    .use(VueProgressBar, options)
    .use(router)
    .use(VueApexCharts)
    .use(BootstrapVue3)
    .component(VueFeather.type, VueFeather)
    .use(Maska)
    .use(Particles)
    .use(i18n)
    .use(Notifications)
    .use(generalMixin)
    .use(vClickOutside);

app.mixin(generalMixin)


app.component('Price', Price)
app.component('Jalali', Jalali)
app.component('NumericValue', NumericValue)
app.mount('#app');

